module.exports = __webpack_public_path__ + "assets/9ae0a0a583a0eadc71025801efd32160.png";